module.exports = __webpack_public_path__ + "static/media/synth_10.d5c3f562.mp3";